import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Utility } from '../utils/app-utils';
import { AuthenticationService } from '../services/authentication.service';
import { ApiConstants } from '../constants/api-constants';


@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss']
})
export class MediaComponent implements OnInit {
  utility = Utility;
  media: any;
  readonly streamAppToken = ApiConstants.STREAM_APP_TOKEN;

  @ViewChild('videoPlayer', { static: true }) videoplayer: ElementRef;

  get streamEngineServerUrl(): string {
    return this.authenticationService.getUser()?.streamServerIP || '';
  }

  get isPlayableCameraStream(): boolean {
    const url = this.media?.url;
    return typeof url === 'string' && /^(rtsp|rtsps|udp):\/\//i.test(url);
  }

  constructor(
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<MediaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authenticationService: AuthenticationService,
  ) { }

  ngOnInit() {
    this.media = this.data;
  }

  openDialog() {
    const dialogRef = this.dialog.open(MediaComponent);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  toggleVideo(event: any) {
    if (this.videoplayer && this.videoplayer.nativeElement) {
      this.videoplayer.nativeElement.play();
    }
  }

}
